import { render, staticRenderFns } from "./GetUndeliveredDispatchesData.vue?vue&type=template&id=7891b2f1&scoped=true&"
import script from "./GetUndeliveredDispatchesData.vue?vue&type=script&lang=js&"
export * from "./GetUndeliveredDispatchesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7891b2f1",
  null
  
)

export default component.exports